
export function beginNoTracking(obj) {
    if (obj.__trackingEnabled) {
        obj.__trackingEnabled(false);
    } else {
        console.warn('beginNoTracking has no effect');
    }
}

export function endNoTracking(obj) {
    if (obj.__trackingEnabled) {
        ko.tasks.runEarly();
        obj.__trackingEnabled(true);
    } else {
        console.warn('endNoTracking has no effect');
    }
}


export function listenToPageDirty(fn) {
    window.addEventListener('change-tracker', (ev) => {
        fn(ev.detail || {});
    })
}

export function resolvePageDirty() {
    window.dispatchEvent(new CustomEvent('dirty-reset'));
}